export const COMMON_PORT_NAME_MAPPING: { [key: string]: number } = {
  web: 80,
  http: 80,
  https: 443,
  grpc: 9090
}

export const MIN_CHECK_DELAY_SECONDS = 3
export const DEFAULT_CHECK_INTERVAL_SECONDS = 5
export const DEFAULT_CHECK_TIMEOUT = 5
export const CHECK_THRESHOLD_PREVENT_TRAFFIC = 2
export const CHECK_THRESHOLD_RESTART = 12

export const PERSISTENT_VOLUME_DEFAULT_SIZE = '10Gi'

export const DEFAULT_REV_HISTORY_LIMIT = 3
export const DEFAULT_REPLICA_DEPLOYMENT = 2
export const DEFAULT_REPLICA_STATEFUL = 1
export const DEFAULT_JOB_COMPLETIONS = 1

export const BUILT_IN_STATEFULSET_ID = 'APP_WORKLOAD_ID'
export const BUILT_IN_ENV_NODE_IP = 'APP_NODE_IP'
export const BUILT_IN_ENV_POD_IP = 'APP_POD_IP'
export const BUILT_IN_ENV_POD_NAME = 'APP_POD_NAME'
export const BUILT_IN_ENV_APP = 'APP_NAME'
export const BUILT_IN_ENV_PORT = 'SERVER_PORT'
export const BUILT_IN_ENV_NAMESPACE = 'APP_NAMESPACE'
export const BUILT_IN_ENV_VERSION = 'APP_VERSION'
export const BUILT_IN_ENV_POD_ID = 'POD_ID'

export const RBAC_API_GROUP = 'rbac.authorization.k8s.io'
export const ROLE_VERB_ALIAS_MAP: { [key: string]: string[] } = {
  "read": ["get", "list", "watch"],
  "write": ["create", "patch", "update", "delete"],
  "all": ["get", "list", "watch", "create", "patch", "update", "delete"],
  "*": ["*"]
}